import { Link } from 'react-router-dom';

import { BreakPoints, Button } from '@kanda-libs/ks-design-library';
import FinanceEverywhereBanner from 'components/FinanceEverywhereBanner';
import SearchBar from 'components/SearchBar';
import { URLS } from 'config';
import {
  CompleteAccountBadge,
  UpgradeAccountBadge,
} from 'pages/Jobs/components/Banner/components';
import LeadsFilters from '../LeadsFilters';
import LeadsFiltersModal from '../LeadsFiltersModal';
import { BUTTON_PROPS, CLASS_NAMES } from './constants';
import useLeadsBanner from './useLeadsBanner';

const LeadsBanner: React.FunctionComponent = function ({}) {
  const {
    showBanner,
    showOptions,
    setupInProgress,
    archive,
    showSubscriptionBanner,
    isLoading,
    showSearch,
  } = useLeadsBanner();
  return (
    <div className={CLASS_NAMES.container}>
      <FinanceEverywhereBanner />
      {setupInProgress && !archive && (
        <div className="mb-8 md:mb-16">
          <CompleteAccountBadge />
        </div>
      )}
      {!setupInProgress && showSubscriptionBanner && (
        <div className="mb-8 md:mb-16">
          <UpgradeAccountBadge />
        </div>
      )}
      <div className={CLASS_NAMES.header}>
        {archive && (
          <div className="hidden md:block md:flex">
            <Link to={URLS.leads} className="-ml-3 mr-3">
              <Button.Icon id="leads-banner-back" icon="arrow-left" size={40} />
            </Link>
          </div>
        )}
        <p className={CLASS_NAMES.title}>
          {archive ? 'Archived Leads' : 'Leads'}
        </p>
        {showBanner && showSearch && (
          <div className="hidden md:flex flex-1 flex-row ml-6 mr-12">
            <SearchBar queryType="leads" isLoading={isLoading} />
          </div>
        )}
        <div className={CLASS_NAMES.options}>
          {showBanner && showOptions && !archive && (
            <>
              <BreakPoints mobile={<LeadsFiltersModal />} />
              <Link to={URLS.leadsArchive} className="ml-2">
                <BreakPoints
                  mobile={<Button.Icon {...BUTTON_PROPS.mobile} />}
                  desktop={<Button.Text {...BUTTON_PROPS.desktop} />}
                />
              </Link>
            </>
          )}
        </div>
      </div>
      {showBanner && showSearch && (
        <div className="flex md:hidden flex-1 flex-row mb-4">
          <SearchBar queryType="leads" isLoading={isLoading} />
        </div>
      )}
      {showBanner && <BreakPoints desktop={<LeadsFilters />} />}
    </div>
  );
};

export default LeadsBanner;
